export class CriteriaObj {
    public criteria: string = '';
    public hasPropForObjectType: { [id: number]: boolean } = {};
}
